<template>
  <div class="toolbar">
    <div>
      <a href="javascript:;" class="icon icon-detail" @click="$emit('intro')">介绍</a>
      <a href="javascript:;" class="icon icon-playlist" @click="$emit('list')">列表</a>
      <a href="javascript:;" class="icon icon-star" :class="{on:favourite}" @click="onFav">收藏</a>
      <a href="javascript:;" class="icon icon-note" @click="onNote">笔记</a>
    </div>
    <a href="javascript:;" class="icon icon-back" @click="$emit('download')"></a>
  </div>
</template>
<script>
export default {
  props: {
    favourite: {}
  },
  methods: {
    async onFav() {
      if (await this.$service.user.checkUserState(this, true)) {
        this.$emit('favourite')
      }
    },
    async onNote() {
      if (await this.$service.user.checkUserState(this, true)) {
        this.$emit('note')
      }
    }
  }
}
</script>
<style scoped lang='scss'>
.toolbar {
  display: flex;
  background-color: #fbfbfb;
  color: $secondly-text-color;
  line-height: 44px;
  border-bottom: $style-border;
  a {
    text-align: center;
    border-right: $style-border;
    font-size: 14px;
    &.on {
      color: orange;
    }
  }
  > div {
    display: flex;
    flex: 1;
    > a {
      flex: 1;
    }
  }
  > a {
    width: 44px;
    border: 0;
  }
}
</style>



// WEBPACK FOOTER //
// Toolbar.vue?a594ab84